document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-site-header]');
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');

  if (menuToggle && header) {
    menuToggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-menu-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchClose = document.querySelector('[data-search-close]');

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }

  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', function () {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchPanel) {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
    }
  });

  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.querySelector('.cart-drawer-overlay');
  var cartOpeners = document.querySelectorAll('[data-cart-drawer-open]');
  var cartClosers = document.querySelectorAll('[data-cart-drawer-close]');

  var cartBusy = false;
  var previousFocus = null;
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openCartDrawer(e) {
    if (!cartDrawer) return;
    if (e) e.preventDefault();
    if (!cartDrawer.classList.contains('is-open')) previousFocus = document.activeElement;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = cartDrawer.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function refreshCartDrawer() {
    var opener = document.querySelector('[data-cart-drawer-open]');
    var cartUrl = opener ? opener.getAttribute('href') : '/cart';

    return fetch(cartUrl, {
      headers: { 'Accept': 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Unable to refresh cart drawer');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshBody = doc.querySelector('#CartDrawer [data-cart-drawer-body]');
        var currentBody = document.querySelector('#CartDrawer [data-cart-drawer-body]');

        if (freshBody && currentBody) {
          currentBody.innerHTML = freshBody.innerHTML;
        }
      });
  }

  cartOpeners.forEach(function (el) {
    el.addEventListener('click', openCartDrawer);
  });

  cartClosers.forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
  });

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-cart-quantity], [data-cart-remove]');
    if (!control || !control.closest('#CartDrawer') || cartBusy) return;
    event.preventDefault();
    var key = control.getAttribute('data-line-key');
    var item = control.closest('[data-cart-item]');
    var quantity = item ? parseInt(item.querySelector('.cart-quantity span').textContent, 10) : 0;
    var nextQuantity = control.hasAttribute('data-cart-remove') ? 0 : Math.max(0, quantity + parseInt(control.getAttribute('data-cart-quantity'), 10));
    cartBusy = true;
    if (cartDrawer) cartDrawer.querySelectorAll('[data-cart-quantity], [data-cart-remove]').forEach(function (btn) { btn.disabled = true; });
    fetch(cartRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: nextQuantity })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (error) { throw new Error(error.description || 'カートを更新できませんでした'); });
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart);
        return refreshCartDrawer();
      })
      .catch(function (error) { window.alert(error.message || 'カートを更新できませんでした。'); })
      .finally(function () {
        cartBusy = false;
        if (cartDrawer) cartDrawer.querySelectorAll('[data-cart-quantity], [data-cart-remove]').forEach(function (btn) { btn.disabled = false; });
      });
  });

  document.querySelectorAll('.product-form').forEach(function (form) {
    var variantInput = form.querySelector('[data-product-form-variant-id]');
    var variantsEl = form.querySelector('[data-product-variants]');
    var submitButton = form.querySelector('[data-product-submit]');
    var variantMediaEl = form.querySelector('[data-variant-media]');
    var productGallery = form.closest('.product-page');
    var variants = [];
    var variantMedia = [];

    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (error) {
        variants = [];
      }
    }

    if (variantMediaEl) {
      try {
        variantMedia = JSON.parse(variantMediaEl.textContent);
      } catch (error) {
        variantMedia = [];
      }
    }

    function updateVariant() {
      if (!variantInput || !variants.length) return;

      var optionGroups = Array.from(form.querySelectorAll('.product-form__option-values'));
      var selectedOptions = optionGroups.map(function (group) {
        var selected = group.querySelector('.product-form__option-value.is-selected');
        return selected ? selected.getAttribute('data-value') : null;
      });

      if (selectedOptions.some(function (value) { return value === null; })) return;

      var matchingVariant = variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedOptions[index];
        });
      });

      if (!matchingVariant) {
        variantInput.value = '';
        if (submitButton) submitButton.disabled = true;
        return;
      }

      variantInput.value = matchingVariant.id;

      var mediaMatch = variantMedia.find(function (entry) {
        return String(entry.id) === String(matchingVariant.id);
      });

      if (mediaMatch && mediaMatch.media_id && productGallery && typeof productGallery.showProductMedia === 'function') {
        productGallery.showProductMedia(mediaMatch.media_id);
      }

      if (submitButton) {
        submitButton.disabled = !matchingVariant.available;
        submitButton.textContent = matchingVariant.available
          ? submitButton.getAttribute('data-add-to-cart-text')
          : submitButton.getAttribute('data-sold-out-text');
      }
    }

    form.querySelectorAll('.product-form__option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.product-form__option-values');

        group.querySelectorAll('.product-form__option-value').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });

        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        updateVariant();
      });
    });

    updateVariant();

    form.addEventListener('submit', function (e) {
      var formData = new FormData(form);

      if (!window.fetch) return;

      e.preventDefault();

      if (submitButton) submitButton.disabled = true;
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (error) { throw new Error(error.description || 'カートに追加できませんでした'); });
          return res.json();
        })
        .then(function () {
          return Promise.all([
            fetch(cartRoot + 'cart.js').then(function (res) {
              if (!res.ok) throw new Error('Unable to refresh cart count');
              return res.json();
            }),
            refreshCartDrawer()
          ]);
        })
        .then(function (results) {
          var cart = results[0];
          updateCartCount(cart);

          openCartDrawer();
        })
        .catch(function (error) {
          window.alert(error.message || 'カートに追加できませんでした。');
        })
        .finally(function () { updateVariant(); });
    });
  });
});